<template lang="html">
  <v-button class="buttom-notification" @click="goToNotification()">
    <v-icon :name="icon" />
    <slot></slot>
    <small>{{ time | moment('from', 'now') }}</small>
  </v-button>
</template>

<script>
import apiVibbrante from '@/api/vibbrante';
import apiClient from '@/api/client';

export default {
  props: ['icon', 'time', 'to'],
  methods: {
    goToNotification() {
      if (this.to.role === 'vibbrante') {
        apiVibbrante
          .vibbranteSetNotificationRead(this.to.id)
          .then(response => {
            if (response.status === 200) {
              if (
                this.to.origin === 'signed-contract' ||
                this.to.origin === 'new-contract' ||
                this.to.origin === 'comment-contract'
              ) {
                this.$router.push({ name: 'vibbrant-clients-pending' });
              }
              if (this.to.origin === 'closed-contract') {
                this.$router.push({ name: 'vibbrant-clients-finalized' });
              }
              if (
                this.to.origin === 'active-contract' ||
                this.to.origin === 'additive-contract'
              ) {
                this.$router.push({
                  name: 'vibbrant-client',
                  params: {
                    id: this.to.code,
                    name: this.to.object_data.client.name,
                  },
                });
              }
              if (this.to.origin === 'comment-task') {
                this.$router.push({
                  name: 'vibbrant-client-task',
                  params: {
                    id: this.to.object_data.contract_id,
                    name: this.to.object_data.client_name,
                    task: this.to.code,
                  },
                });
              }
              if (this.to.origin === 'sprint-approved') {
                this.$router.push({ name: 'vibbrant-wallet' });
              }
              if (this.to.origin === 'credit-approved') {
                this.$router.push({
                  name: 'vibbrant-client',
                  params: {
                    id: this.to.code,
                    name: this.to.object_data.client.name,
                  },
                });
              }
              apiVibbrante
                .vibbranteNotifications()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadVibbranteNotifications',
                      response.data
                    );
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        apiClient
          .clientSetNotificationRead(this.to.id)
          .then(response => {
            if (response.status === 200) {
              if (
                this.to.origin === 'signed-contract' ||
                this.to.origin === 'comment-contract'
              ) {
                this.$router.push({ name: 'client-vibbrants-pending' });
              }
              if (this.to.origin === 'closed-contract') {
                this.$router.push({ name: 'client-vibbrants-finalized' });
              }
              if (this.to.origin === 'create-task') {
                this.$router.push({
                  name: 'client-vibbrant',
                  params: { id: this.to.object_data.contract_id },
                });
              }
              if (this.to.origin === 'comment-task') {
                this.$router.push({
                  name: 'client-vibbrant-task',
                  params: {
                    id: this.to.object_data.contract_id,
                    task: this.to.code,
                  },
                });
              }
              if (this.to.origin === 'active-contract') {
                this.$router.push({ name: 'client-wallet' });
              }
              if (this.to.origin === 'credit-approved') {
                this.$router.push({ name: 'client-wallet' });
              }
              if (this.to.origin === 'sprint-closed') {
                this.$router.push({
                  name: 'client-vibbrant',
                  params: { id: this.to.code },
                });
              }
              apiClient
                .clientNotifications()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadClientNotifications',
                      response.data
                    );
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
  },
};
</script>

<style lang="scss">
.button.buttom-notification {
  white-space: normal;
  width: 320px;
  text-align: left;
  font-size: 0.9em;

  & > .button-inner {
    display: block;
    text-align: left;
    padding: 0 10px 0 44px;
    position: relative;
  }
  small {
    display: block;
    color: gray(400);
  }
  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    font-size: 2em;
    color: gray(300);
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/modules/button-notification.vue